module.exports = __webpack_public_path__ + "img/veb-rf-en.fbc78f5.svg";